import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { isRatingValue } from '@/components/zoho/fieldGrouping';

function RatingBar({ value }) {
  const num = parseFloat(value);
  const max = num <= 5 ? 5 : 10;
  const pct = (num / max) * 100;
  const color = pct >= 80 ? 'bg-green-500' : pct >= 50 ? 'bg-amber-500' : 'bg-red-500';
  return (
    <div className="flex items-center gap-2">
      <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
        <div className={`h-full rounded-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-sm font-semibold">{num}/{max}</span>
    </div>
  );
}

function FieldValue({ value }) {
  const str = String(value || '');
  if (isRatingValue(value)) return <RatingBar value={value} />;
  return <span className="text-sm">{str || '\u2014'}</span>;
}

export default function ZohoEntitySection({ section }) {
  return (
    <Card data-testid={`section-${section.key}`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold">{section.label}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          {section.fields.map(({ key, value }) => (
            <div key={key} className="space-y-0.5">
              <p className="text-xs text-muted-foreground">{key}</p>
              <FieldValue value={value} />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
